export default __webpack_public_path__ + "css/supplierNotes.bundle.css";